import { isRouteErrorResponse } from 'react-router';

import { translate } from '@/ui/i18n';

export function formatErrorMessage(error: unknown): string {
  if (error === undefined) {
    return translate('Error.unknown-error');
  }
  if (isRouteErrorResponse(error)) {
    return `${error.status} ${error.statusText}`;
  } else if (error instanceof Error) {
    return error.message;
  } else if (typeof error === 'string') {
    return error;
  } else {
    console.error(error);
    return translate('Error.unknown-error');
  }
}
